/**
 * Presence Service
 *
 * Sends periodic heartbeats to the backend to track online status.
 * Heartbeat interval: every 5 minutes while the tab is active.
 */

import { apiRequest } from '../config/api';

const HEARTBEAT_INTERVAL = 5 * 60 * 1000; // 5 minutes

class PresenceService {
  private intervalId: ReturnType<typeof setInterval> | null = null;

  start() {
    if (this.intervalId) return;
    this.sendHeartbeat(); // Send immediately
    this.intervalId = setInterval(() => this.sendHeartbeat(), HEARTBEAT_INTERVAL);

    // Send heartbeat when tab becomes visible
    document.addEventListener('visibilitychange', this.handleVisibility);
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    document.removeEventListener('visibilitychange', this.handleVisibility);
  }

  private handleVisibility = () => {
    if (document.visibilityState === 'visible') {
      this.sendHeartbeat();
    }
  };

  private async sendHeartbeat() {
    try {
      await apiRequest('/auth/presence', { method: 'POST' });
    } catch {
      // Silent fail — presence is best-effort
    }
  }
}

export const presenceService = new PresenceService();
